 const API = "https://freelancer-clone-git-main-deepakkumar2205.vercel.app"
//  const API = "http://localhost:4000"

 export default API